import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"

const getListDataSiswa = async (
  page: string,
  rowsPerPage: string,
  searchQuery: string
) => {
  const response = await api.get(
    `/data-siswa/index?page=${page}${
      rowsPerPage ? `&rowsPerPage=${rowsPerPage}` : ""
    }${searchQuery ? `&searchQuery=${searchQuery}` : ""}`,
    {
      withCredentials: true,
    }
  )
  return response.data?.data
}

export default function DataSiswaPage() {
  const [searchParams] = useSearchParams()
  const pageParams = searchParams.get("page")
  const rowsPerPageParams = searchParams.get("rowsPerPage")
  const searchQueryParams = searchParams.get("search")

  const { data, isPending } = useQuery({
    queryKey: [
      "listDataSiswa",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
    ],
    queryFn: () =>
      getListDataSiswa(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string
      ),
  })

  return (
    <div>
      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
        isPending={isPending}
      />
    </div>
  )
}
